import type { SxProps, Theme } from '@mui/material';

export const radioControlRootSx: SxProps<Theme> = {
  display: 'flex',
};
